export default "__VITE_ASSET__BQCz$_hi__ 430w";